var _a;
import { ApiTypes } from '../sdk.types';
import { DocumentParser } from './documentParser';
import * as messagesEn from '../../assets/locales/messages_en.json';
var DOCUMENT_TYPE_I18N_KEYS = (_a = {},
    _a[ApiTypes.SearchDocumentType.All] = 'documentType.title.all',
    _a[ApiTypes.SearchDocumentType.Pages] = 'documentType.title.pages',
    _a[ApiTypes.SearchDocumentType.Products] = 'documentType.title.products',
    _a[ApiTypes.SearchDocumentType.Blogs] = 'documentType.title.blogs',
    _a[ApiTypes.SearchDocumentType.Forums] = 'documentType.title.forums',
    _a[ApiTypes.SearchDocumentType.Bookings] = 'documentType.title.bookings',
    _a[ApiTypes.SearchDocumentType.Events] = 'documentType.title.events',
    _a);
function groupBy(array, key) {
    return array.reduce(function (objectsByKeyValue, obj) {
        var keyValue = key(obj);
        objectsByKeyValue[keyValue] = (objectsByKeyValue[keyValue] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}
function initTranslations(language) {
    var messages = messagesEn;
    try {
        messages = require("../../assets/locales/messages_" + language + ".json");
    }
    catch (e) {
        //
    }
    return function getDocumentTypeTitle(documentType) {
        var key = DOCUMENT_TYPE_I18N_KEYS[documentType];
        if (!key) {
            return documentType;
        }
        return messages[key] || messagesEn[key] || documentType;
    };
}
var SuggestionsParser = /** @class */ (function () {
    function SuggestionsParser(siteBaseUrl, language, useEmptyImages) {
        if (useEmptyImages === void 0) { useEmptyImages = false; }
        this.documentParser = new DocumentParser(siteBaseUrl, useEmptyImages);
        this.getDocumentTypeTitle = initTranslations(language);
    }
    SuggestionsParser.prototype.parse = function (suggestions) {
        var _this = this;
        var grouped = groupBy(suggestions, function (v) { return v.documentType; });
        var parse = function (document) {
            return _this.documentParser.parse(document);
        };
        var groupedSuggestions = Object.keys(grouped).map(function (documentType) { return ({
            title: _this.getDocumentTypeTitle(documentType),
            documentType: documentType,
            options: grouped[documentType].map(parse),
        }); });
        return groupedSuggestions;
    };
    return SuggestionsParser;
}());
export { SuggestionsParser };
//# sourceMappingURL=SuggestionsParser.js.map